import { useMemo } from 'react';

const useLengthMessage = (current: number | undefined, expected: number | [number] | undefined) => {
    return useMemo(() => {
        let expectedLength: number | undefined = 0;

        // We grab the first expected length, but if multiple
        // are defined we don't display expected length at all
        // as per the legacy implementation (not sure why!).
        if (Array.isArray(expected)) {
            if (expected.length === 1) {
                expectedLength = expected[0];
            }
        } else {
            expectedLength = expected;
        }

        const display = current ?? 0;

        if (expectedLength === 0 || expectedLength === undefined) {
            return `${display}`;
        }
        return `${display}/${expectedLength}`;
    }, [current, expected]);
};

export { useLengthMessage };
